import { Injectable } from '@angular/core';
import { ToastConfig } from '@ngxpert/hot-toast';
import { AppInsightsConfig } from '../libs/modules/app-insights/app-insights-config';

export namespace ConfigurationModels {
  @Injectable({
    providedIn: 'root',
  })
  export class Configuration {
    private static _curr: Configuration;
    // file
    applicationPaths!: ApplicationPaths;
    toasterConfig!: ToastConfig;
    appInsights!: AIConfig;
    googleMapsApiKey!: string;
    brokerApp!: BrokerAppConfig;
    backofficeApp!: BackofficeAppConfig;
    // runtime
    apiRootUrl!: string;
    logging!: LoggingConfig;
    static get Current() {
      return this._curr;
    }
    static setGlobal(config: Configuration) {
      this._curr = Object.assign({}, config);
    }
  }

  export class FileConfiguration {
    applicationPaths!: ApplicationPaths;
    toasterConfig!: ToastConfig;
    apiRootUrl!: string;
    logging!: LoggingConfig;
  }

  export class LoggingConfig {
    defaultLogger!: boolean;
    loggers!: string[];
  }

  export class ApplicationPaths {
    appClientUrl!: string;
    appBrokerUrl!: string;
    appTunnelUrl!: string;
    appZenithUrl!: string;
    appAfiUrl!: string;
    appGestionUrl!: string;
    appTunnelSanteUrl!: string;
  }

  export class AIConfig extends AppInsightsConfig {
    brokerKey!: string;
    clientKey!: string;
    backOfficeKey!: string;
  }

  export interface BrokerAppConfig {
    support: SupportConfig;
    avenant: HealthSupportConfig;
    termination: HealthSupportConfig;
    refundInfo: HealthSupportConfig;
    quantieme: HealthSupportConfig;
    supportTeams: SupportTeam[];
    rop: Rop;
  }

  export interface BackofficeAppConfig {
    smalltoxUrl: string;
  }

  export interface HealthSupportConfigs {}

  export interface HealthSupportConfig {
    phone: string;
    phoneInfo: string;
    email: string;
  }

  export interface SupportConfig {
    svaNumber: string;
    email: string;
  }

  export interface SupportTeam {
    contacts: SupportContact[];
    products: SupportProduct[];
    type: string;
  }

  export interface Rop {
    effectDatesRange: number;
  }

  export interface SupportContact {
    name?: string;
    phone?: string;
    address1?: string;
    address2?: string;
    title?: string;
    email?: string[];
    type: string;
    products: SupportProduct[];
  }

  export type SupportProduct = 'car' | 'health';
}
